import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { formatNumberToHumanOutput } from '../../../util/misc';
import { IconSpinner } from '../../../components';
import css from './SectionStats.module.css';

const SectionStats = (props) => {
    const {
        budgetDetails,
        getBudgetInProgress,
        getBudgetError,
    } = props;

    const {
        totalSearchBudget,
        totalSellBudget,
    } = budgetDetails || {};

    const formattedSearchBuget = totalSearchBudget
        ? formatNumberToHumanOutput(totalSearchBudget)
        : 0;
    const formattedSellBuget = totalSellBudget
        ? formatNumberToHumanOutput(totalSellBudget)
        : 0;

    return <div className={css.root}>
        <div className={css.point}>
            <div className={css.figure}>
                {getBudgetInProgress ? <IconSpinner /> : formattedSearchBuget}
            </div>
            <div className={css.text}>
                <FormattedMessage id="MLP.stats.searchBudget" />
            </div>
        </div>

        <div className={css.point}>
            <div className={css.figure}>
                {getBudgetInProgress ? <IconSpinner /> : formattedSellBuget}
            </div>
            <div className={css.text}>
                <FormattedMessage id="MLP.stats.sellBudget" />
            </div>
        </div>

        <div className={css.point}>
            <div className={css.figure}>
                <FormattedMessage id="MLP.stats.countriesCount" />
            </div>
            <div className={css.text}>
                <FormattedMessage id="MLP.stats.countriesLabel" />
            </div>
        </div>
    </div>
};

export default SectionStats;
